import { useEffect } from "react";
import { useAppContext } from "@/contexts/AppContext";

export type Theme = "light" | "dark" | "system";

function getSystemPrefersDark() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function applyTheme(theme: Theme) {
  const root = document.documentElement;

  const dark = theme === "dark" || (theme === "system" && getSystemPrefersDark());

  root.classList.toggle("dark", dark);
}

export function useTheme() {
  const { theme, setTheme } = useAppContext();

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  useEffect(() => {
    if (theme !== "system") return;

    const mq = window.matchMedia("(prefers-color-scheme: dark)");

    const handler = (event: MediaQueryListEvent) => {
      document.documentElement.classList.toggle("dark", event.matches);
    };

    mq.addEventListener("change", handler);

    return () => {
      mq.removeEventListener("change", handler);
    };
  }, [theme]);

  return {
    theme,
    setTheme,
  };
}
